import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Card } from "../CardFactory";
import { upsertSettings } from "../services/UserSettingService";

interface CardPayload {
    type: string;
    elementGuid: string;
    name: string;
}

interface DashboardState {
    cards: Card[],
}

const initialState: DashboardState = {
    cards: []
};

const dashboardSlice = createSlice({
    name: "cards",
    initialState,
    reducers: {
        addCard: (state, action: PayloadAction<CardPayload>) => {
            const newCard: Card = { type: action.payload.type, elementGuid: action.payload.elementGuid, name: action.payload.name };
            state.cards.push(newCard);
            upsertSettings<DashboardState>("dashboard", state);

        },
        addCardWithoutSaving: (state, action: PayloadAction<CardPayload>) => {
            const newCard: Card = { type: action.payload.type, elementGuid: action.payload.elementGuid, name: action.payload.name };
            state.cards.push(newCard);
        },
        removeCard: (state, action: PayloadAction<{ eguid: string, type: string }>) => {
            state.cards = state.cards.filter(card => card.elementGuid !== action.payload.eguid || card.type !== action.payload.type);
            upsertSettings<DashboardState>("dashboard", state);

        },
        reorderCards: (state, action: PayloadAction<string[]>) => {
            const orderedGuids = action.payload;
            state.cards = orderedGuids
                .map(eguid => state.cards.find(card => card.elementGuid === eguid))
                .filter((card): card is Card => card !== undefined);
            upsertSettings<DashboardState>("dashboard", state);
        }
    },
});

export const { addCard, removeCard, addCardWithoutSaving, reorderCards } = dashboardSlice.actions;
export default dashboardSlice.reducer;